import { FC } from 'react';
import { Text } from '@bpba/ui-components';
import { GenericWarningContainer } from './GenericWarningContainer';
import { DEBIN_PENDING_WARNING_TEXT1, DEBIN_PENDING_WARNING_TEXT2, DEBIN_PENDING_WARNING_TEXT3 } from '../constants/data';

/**
 * Componente informativo que se muestra luego de confirmar
 * el envío del DEBIN a la cuenta bancaria del usuario.
 */
export const DebinPendingWarning: FC = () => {
  return (
    <GenericWarningContainer>
      <Text>{DEBIN_PENDING_WARNING_TEXT1}</Text>
      <Text fontWeight={600}>{DEBIN_PENDING_WARNING_TEXT2}</Text>
      <Text>{DEBIN_PENDING_WARNING_TEXT3}</Text>
    </GenericWarningContainer>
  );
};
